import MiniCart from './mini-cart-view'

export default MiniCart
